import APIRequestState from './_util/api-request';

class UpdateSearchAttemptState extends APIRequestState {
  getRequest(params, body) {
    return this.ctx.sdk.put(`/searchAttempt/${params.id}`, body);
  }
}

export default UpdateSearchAttemptState;



// WEBPACK FOOTER //
// ./spa/state/update-search-attempt.jsx